import { render } from "./IconInvestedRoundedType11.vue?vue&type=template&id=763bef49&ts=true"
import script from "./IconInvestedRoundedType11.vue?vue&type=script&lang=ts"
export * from "./IconInvestedRoundedType11.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__